import React from 'react';
import Grid from "@material-ui/core/Grid/Grid";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";

export default function AppCardLoaderSidebar() {
    return (
        <Grid container spacing={2} justify="center" alignItems="center">
            <Grid item xs={4} style={{minHeight:150,marginTop:100}}>
                <CircularProgress/>
            </Grid>
        </Grid>
    );
}